import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "datalist", "dialog", "panel"]

  check() {
    const option = this.datalistTarget.querySelector(
      `option[value="${CSS.escape(this.inputTarget.value.trim())}"]`,
    )
    const canton = option?.dataset.canton

    if (!['BL', 'VS'].includes(canton)) return

    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.canton !== canton
    })
    if (!this.dialogTarget.open) this.dialogTarget.showModal()
  }

  close(event) {
    event?.preventDefault()
    if (this.dialogTarget.open) this.dialogTarget.close()
    this.inputTarget.focus()
  }

  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }
}
